import BlogsSection from "./blogs";
import CTASection from "./cta";
import DevOpsSection from "./dev-ops";
import IntegrationSection from "./integrations";
import LoggedInHeroSection from "./logged-in-hero/logged-in-hero";
import JiraPlainBanners from "./plain-banners";
import ScalingSection from "./scaling";
import TabsSection from "./tabs";
import WorkflowSection from "./workflow";

export {
    JiraPlainBanners,
    BlogsSection,
    CTASection,
    DevOpsSection,
    LoggedInHeroSection,
    IntegrationSection,
    ScalingSection,
    TabsSection,
    WorkflowSection
};
